import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n/i18n"; // initialise i18next before React tree
import "./stores/theme"; // apply saved theme to DOM early
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
